import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/layout/Layout';
import Login from './pages/auth/Login';
import Dashboard from './pages/Dashboard';
import ClientsPage from './pages/clients/ClientsPage';
import AnimauxPage from './pages/animaux/AnimauxPage';
import ConsultationsPage from './pages/consultations/ConsultationsPage';
import MedicamentsPage from './pages/medicaments/MedicamentsPage';
import DettesPage from './pages/dettes/DettesPage';
import SuperAdminDashboard from './pages/super-admin/SuperAdminDashboard';
import UsersManagement from './pages/admin/UsersManagement';
import UsersMonitoring from './pages/super-admin/UsersMonitoring';
import PermissionsManagement from './pages/super-admin/PermissionsManagement';
import LicencesManagement from './pages/super-admin/LicencesManagement';

// ====== NOUVELLES IMPORTS POUR LA GESTION DE STOCK ======
import StockSecretairePage from './pages/stock/StockSecretairePage';
import StockTechnicienPage from './pages/stock/StockTechnicienPage';
import StockVeterinairePage from './pages/stock/StockVeterinairePage';
// ========================================================

const theme = createTheme({
  palette: {
    primary: {
      main: '#3d7a7f', 
      light: '#5a9a9f',
      dark: '#2d6a6f',
      contrastText: '#fff',
    },
    secondary: {
      main: '#3d7a7f',
      light: '#5a9a9f',
      dark: '#2d6a6f',
      contrastText: '#fff',
    },
  },
});

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Chargement...</div>;
  }

  return user ? children : <Navigate to="/login" />;
};

function AppRoutes() {
  const { user } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to={user.role === 'Super Admin' ? '/super-admin' : '/dashboard'} /> : <Login />} />
      
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <Layout>
              <Routes>
                {/* Routes Super Admin */}
                {user?.role === 'Super Admin' ? (
                  <>
                    <Route path="/super-admin" element={<SuperAdminDashboard />} />
                    <Route path="/super-admin/users" element={<UsersMonitoring />} />
                    <Route path="/super-admin/permissions" element={<PermissionsManagement />} />
                    <Route path="/super-admin/licences" element={<LicencesManagement />} />
                    <Route path="/" element={<Navigate to="/super-admin" />} />
                  </>
                ) : (
                  <>
                    {/* Routes normales */}
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/clients" element={<ClientsPage />} />
                    <Route path="/animaux" element={<AnimauxPage />} />
                    <Route path="/consultations" element={<ConsultationsPage />} />
                    <Route path="/medicaments" element={<MedicamentsPage />} />
                    <Route path="/dettes" element={<DettesPage />} />
                    
                    {/* ====== NOUVELLES ROUTES POUR LA GESTION DE STOCK ====== */}
                    {/* Route pour Secrétaire et Vétérinaire : Stock Principal */}
                    {(user?.role === 'Secrétaire' || user?.role === 'Vétérinaire' || user?.role === 'Admin') && (
                      <Route path="/stock/principal" element={<StockSecretairePage />} />
                    )}
                    
                    {/* Route pour Technicien : Mon Stock Personnel */}
                    {user?.role === 'Technicien' && (
                      <Route path="/stock/technicien" element={<StockTechnicienPage />} />
                    )}
                    
                    {/* Route pour Vétérinaire : Vue d'ensemble de tous les stocks */}
                    {(user?.role === 'Vétérinaire' || user?.role === 'Admin') && (
                      <Route path="/stock/veterinaire" element={<StockVeterinairePage />} />
                    )}
                    {/* ======================================================= */}
                    
                    {user?.role === 'Vétérinaire' && (
                      <Route path="/users" element={<UsersManagement />} />
                    )}
                    <Route path="/" element={<Navigate to="/dashboard" />} />
                  </>
                )}
              </Routes>
            </Layout>
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;